import type { TimeRangeKey } from '../../../redux/adminAnalyticsSlice';

export const PAGE_TITLE = 'Admin Analytics Dashboard';
export const PAGE_SUBTITLE = "Comprehensive insights into your platform's performance";

export const TIME_RANGE_OPTIONS: { value: TimeRangeKey; label: string }[] = [
  { value: '7d', label: 'Last 7 Days' },
  { value: '30d', label: 'Last 30 Days' },
  { value: '90d', label: 'Last 90 Days' },
  { value: '1y', label: 'Last Year' },
];

export const STAT_LABELS = {
  TOTAL_REVENUE: 'Total Revenue',
  TOTAL_REVENUE_HELP: 'Platform earnings',
  TOTAL_TRANSACTIONS: 'Total Transactions',
  TOTAL_TRANSACTIONS_HELP: 'Processed payments',
  ACTIVE_SESSIONS: 'Active Sessions',
  ACTIVE_SESSIONS_HELP: 'Live devices',
} as const;

export const SESSIONS_TITLE = 'Current Sessions Details';
export const SESSIONS_EMPTY = 'No active sessions available';
export const SESSIONS_TABLE_DEVICE_NAME = 'Device Name';
export const SESSIONS_TABLE_DEVICE_BRAND = 'Device Brand';
export const SESSIONS_TABLE_DEVICE_TYPE = 'Device Type';

export const SECTION_TITLES = {
  REVENUE: 'Revenue Analysis',
  TRANSACTION: 'Transaction Analysis',
  MERCHANT: 'Merchant Analysis',
  DEVICE: 'Device Analysis',
  CUSTOMER: 'Customer Insights',
  SUPPORT: 'Support & Tickets',
  CUSTOM_REPORTS: 'Custom Reports',
} as const;

export const ANALYSIS_LABELS = {
  TOTAL_REVENUE: 'Total Revenue:',
  REVENUE_GROWTH: 'Revenue growth trend analysis',
  SUCCESS_RATE: 'Success Rate:',
  AVG_VALUE: 'Avg Value:',
  TOP_MERCHANTS: 'Top Merchants:',
  TOP_MERCHANTS_NA: 'No top merchants data available',
  ACTIVE_DEVICES: 'Active Devices:',
  DEVICE_ERRORS: 'Device Errors:',
  RETENTION_RATE: 'Retention Rate:',
  FEEDBACK_SCORE: 'Feedback Score:',
  RESOLUTION_TIME: 'Resolution Time:',
  COMMON_ISSUES: 'Common Issues:',
  COMMON_ISSUES_NA: 'No common issues reported',
  CUSTOM_REPORTS_DESC: 'Generate custom reports based on selected filters and criteria.',
  GENERATE_REPORT: 'Generate Report',
} as const;

export const DEFAULT_NA = 'N/A';
